import { BLOCK_CLASSES as t } from "../../constants.js";
import { defineAttrs as e } from "../../utils/typed-attrs.js";
const r = e({
  type: { default: "spacer" },
  height: { default: 20 }
}), s = {
  content: "",
  group: "block",
  attrs: r,
  toDOM(o) {
    return [
      "div",
      {
        class: `${t.blockContainer} ${t.spacer} intercom-spacer-container`
      }
    ];
  }
};
export {
  s as spacerSpec
};
